// eslint-disable-next-line no-restricted-imports
import { SaveLegalClientOnboardingStatusDto_Input } from 'api/generated/graphql';
import { LegalClientOnboardingStatusType } from 'api/types/entity';
import { SaveOnboardingStatusParam } from 'api/types/params';

import { parseLegalClientOnboardingStatusParam } from './parseLegalClientOnboardingStatusParam';

export const parseSaveLegalClientOnboardingStatusParam = (
  param: SaveOnboardingStatusParam<LegalClientOnboardingStatusType>
): SaveLegalClientOnboardingStatusDto_Input => ({
  value: parseLegalClientOnboardingStatusParam(param.value),
  versionNumber: param.versionNumber,
  result: param.result,
});
